import { SortMode } from '@qality/common-model/src/sorting/Sort';

import { TestCycleSortStrategy } from '../../TestCycleSorter/TestCycleSorter.util';

export const TypeSortingStrategy: Record<SortMode, TestCycleSortStrategy> = {
  asc: 'type-asc',
  dsc: 'type-dsc',
  none: 'none',
};

export const SummarySortingStrategy: Record<SortMode, TestCycleSortStrategy> = {
  asc: 'summary-asc',
  dsc: 'summary-dsc',
  none: 'none',
};

export const StatusSortingStrategy: Record<SortMode, TestCycleSortStrategy> = {
  asc: 'status-asc',
  dsc: 'status-dsc',
  none: 'none',
};

export const ExecutionAssigneeSortingStrategy: Record<
  SortMode,
  TestCycleSortStrategy
> = {
  asc: 'execution-assignee-asc',
  dsc: 'execution-assignee-dsc',
  none: 'none',
};

export const NumberOfBugsSortingStrategy: Record<
  SortMode,
  TestCycleSortStrategy
> = {
  asc: 'number-of-bugs-asc',
  dsc: 'number-of-bugs-dsc',
  none: 'none',
};
